module.exports = __webpack_public_path__ + "5208e5f8.png";